"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableJsonNullValueInputSchema = void 0;
const tslib_1 = require("tslib");
const zod_1 = require("zod");
const transformJsonNull_1 = tslib_1.__importDefault(require("./transformJsonNull"));
exports.NullableJsonNullValueInputSchema = zod_1.z.enum(['DbNull', 'JsonNull',]).transform((v) => (0, transformJsonNull_1.default)(v));
exports.default = exports.NullableJsonNullValueInputSchema;
//# sourceMappingURL=NullableJsonNullValueInputSchema.js.map